module.exports = __webpack_public_path__ + "img/house-building.5cc4c26b.svg";